"use client";

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { getLocaleFromPathname } from '@/lib/i18n';
import { getToolUiCopy } from '@/lib/tool-ui-copy';

function DocumentCreateLoading() {
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const ui = getToolUiCopy(locale);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-positivus-green mx-auto mb-4"></div>
        <p className="text-lg text-gray-700">{ui.loadingPdfEditor}</p>
      </div>
    </div>
  );
}

// Disable SSR completely for this page to avoid canvas module issues
const DocumentEditorContent = dynamic(
  () => import('./DocumentEditorContent'),
  { 
    ssr: false,
    loading: () => <DocumentCreateLoading />
  }
);

export default function DocumentCreatePage() {
  return <DocumentEditorContent />;
}
